import React, { useEffect, useState, useMemo } from 'react';
import { Skeleton } from "@mui/material";
import Box from "@mui/material/Box";
import Card from '@mui/material/Card';
import {orderBy} from 'lodash';
import parse from "html-react-parser";

const Parcerias = (params) => {

  const baseUrl = process.env.REACT_APP_API_URL || window.location.origin;
  const url = useMemo(() => `${baseUrl}/content/parcerias`, [baseUrl]);
  const requestHeaders = useMemo(() => {
    const headers = new Headers();
    headers.append("X-Frontend-Client", "react-app");
    return headers;
  }, []);
  const [pages, setPages] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = () => {
      fetch(url, {
        method: 'GET',
        headers: requestHeaders
        })
        .then((response) => response.json())
        .then((result) => {
          setPages(result);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    }
    fetchData();
  }, [url, requestHeaders]);

  return (
    <div>
        {isLoading
          ?
            <Skeleton sx={{ bgcolor: 'rgba(255, 255, 255, 0.5)' }} variant="rectangular" width={210} height={25} animation="wave" className="skeleton_FE"/>
          :
            <Box className="transparencia_list">
            {orderBy(pages, ['id'])
            .filter(filterPage => (filterPage.Status !== "Rascunho"))
            .map(page => (
              <Card className="transparencia_card" key={page.id}>
                <div className="parceria_item"  key={page.id}>
                  <h4>{page.titulo}</h4>
                  <p>Descrição:</p>
                  <div>{parse(page.Descricao)}</div>
                </div>
              </Card>
            ))}
            </Box>
        }
    </div>
  );
};

export default Parcerias;

